import * as React from "react";
import IndividualContact from "../../../model/contact/IndividualContact";
import SelectComponent, {SelectComponentComponentProps, SelectComponentReduxProps} from "../../ui/select/SelectComponent";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import {option} from "ts-option";
import * as _ from "underscore";

/**
 * Component for selection of an individual contact.
 */
class SelectContactComponent extends SelectComponent<IndividualContact> {

	matchFilter(element: IndividualContact, filter: string): boolean {
		return element.data.searchString.indexOf(filter.toLowerCase()) > -1;
	}

	elementToId(element: IndividualContact): string {
		return element.id;
	}

	elementToString(element: IndividualContact): string {
		return element.data.displayName();
	}
}

function mapStateToProps(state: RootState) {
	return {
		items: option(_.values(state.contact.individualContactMap))
	}
}

export default connect<SelectComponentReduxProps<IndividualContact>, SelectComponentComponentProps<IndividualContact>>(
	mapStateToProps, null, null, {withRef: true}
)(SelectContactComponent)